import { Component, Input, Output, EventEmitter, inject, OnInit, OnDestroy } from '@angular/core';
import { MaterialModule } from '@app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalsViewComponent } from '@components/modals/modals-view/modals-view.component';
import { TechnicianApiService } from '@services/api/user/technician/technician-api.service';
import { Subject, takeUntil } from 'rxjs';
import { ProfileComponent} from '@pages/users/technicians/profile/profile.component';
import { Technician} from '@interfaces/technician';
import { ToastrServices } from '@services/toastr/toastr.service';
import { EmailComponent } from '@pages/users/technicians/email/email.component';

@Component({
  selector: 'app-card-user',
  imports: [MaterialModule, TablerIconsModule, CommonModule, TranslateModule],
  standalone: true,
  templateUrl: './card-user.component.html',
  styleUrl: './card-user.component.scss'
})
export class CardUserComponent implements OnInit, OnDestroy {
  @Input() technician: Technician | null = null;
  @Output() technicianDeleted = new EventEmitter<void>();
  private technician_api_service = inject(TechnicianApiService);
  private toastr_service = inject(ToastrServices);
  private destroy$ = new Subject<void>();
  qrcode: string = "";

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    if (this.technician){
      this.technician_api_service.get_qrcode(this.technician.id)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response) => {
            this.qrcode = response.data.qrcode;
          },
          error: (error) => {
            console.log(error);
          }
        });
    }
  }

  viewFile(){
    this.showFile(this.qrcode);
  }

  showFile(base64String: string) {
    const mimeType = this.getMimeTypeDaBase64(base64String);
    const imageData = {
      name: 'QR Code',
      content_type: mimeType,
      decrypted_file: base64String
    };

    this.dialog.open(ModalsViewComponent, {
      data: imageData,
      width: '40vw',
      minHeight: '200px',
      maxHeight: '90vw',
      maxWidth: '50vw',
    });
  }

  getMimeTypeDaBase64(base64String: string): string | null {
    const match = base64String.match(/^data:(image\/[a-zA-Z0-9.+_-]+);base64,/);
    return match ? match[1] : null;
  }

  downloadQrcode() {
    if (this.qrcode) {
      const link = document.createElement('a');
      link.href = this.qrcode;
      link.download = `qrcode_${this.technician?.id || 'unknown'}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.warn('Nessun QR code disponibile per il download.');
    }
  }

  openTechnician(user: Technician | null): void{
    const dialogRef = this.dialog.open(ProfileComponent, {
      data: user,
      autoFocus: false,
      width: '50vw',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.deleted === true) {
        this.toastr_service.showSuccess('Technician deleted successfully', 'Success');
        this.technicianDeleted.emit();
        return;
      }

      if (result?.deleted === false) {
        this.toastr_service.showError('Unable to delete technician', 'Error');
        return;
      }

      if (result) {
        this.toastr_service.showSuccess('Technician update succesfully', 'Success');
        this.technician = {
          ...(this.technician || {}),
          ...(result.data || {})
        } as Technician;
      }
    }, error => {
      console.error('Errore dalla modale:', error);
      this.toastr_service.showError('Error', 'Error');
    });
  }

  sendEmail(user: Technician | null): void{
    const dialogRef = this.dialog.open(EmailComponent, {
      data: {
        "technician_email": user?.email,
        "qr_code":this.qrcode
      },
      autoFocus: false,
      width: '50vw',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'close' || !result) {
        //
      } else {
        if (result.success) {
          this.toastr_service.showSuccess('Emails sends succesfully', 'Success');
        } else if (!result.success ) {
          this.toastr_service.showError('Emails not sends', 'Error');
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
